import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'isTAccountViewEnabled';

export const useTAccountView = (enabled: boolean): [boolean, (val: boolean) => void] => {
  const [isTAccountViewEnabled, setIsTAccountViewEnabled] = useState(() => {
    if (!enabled) return false;
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      return stored ? (JSON.parse(stored) as boolean) : false;
    } catch {
      return false;
    }
  });

  // Keep in sync with SortAndPagination which still dispatches the legacy event
  useEffect(() => {
    if (!enabled) return;
    const handler = (event: Event) => {
      const e = event as CustomEvent<{ enabled: boolean }>;
      setIsTAccountViewEnabled(e.detail.enabled);
    };
    window.addEventListener('isTAccountViewEnabledChanged', handler);
    return () => window.removeEventListener('isTAccountViewEnabledChanged', handler);
  }, [enabled]);

  const set = useCallback((val: boolean) => {
    setIsTAccountViewEnabled(val);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(val));
    window.dispatchEvent(new CustomEvent('isTAccountViewEnabledChanged', { detail: { enabled: val } }));
  }, []);

  return [isTAccountViewEnabled, set];
};
